import { Outlet, ScrollRestoration } from "react-router-dom";
import ScrollToTop from "../shared/ScrollToTop";
import Seo from "../shared/Seo";
import Navbar from "./Navbar";
import Footer from "./Footer";
import LiveChat from "./LiveChat";
import SizingBoard from "./SizingBoard";
import { useContext } from "react";
import { ToggleContext } from "../../../ToggleProvider";
import { useSelector } from "react-redux";
import { useLocation } from 'react-router-dom';
import CriteoOneTag from "../shared/CriteoOneTag";

export default function RootLayout() {
    const { isToggled, setIsToggled } = useContext(ToggleContext);
    const loginUser = useSelector(state => state.userReducer.user);
    const { pathname } = useLocation();
    const siteId = useSelector(state => state.commonReducer.siteId);

    return (
        <>
            <CriteoOneTag />
            <Seo />
            <Navbar />
            {isToggled && loginUser.UserID && pathname !== '/login' &&
                <SizingBoard key={siteId} siteId={siteId} />
            }
            <Outlet />
            <Footer />
            {loginUser.UserID &&
                <LiveChat />
            }
            <ScrollRestoration />
        </>
    );
}